export const SERVICE_CODE = 'GLOBALS' + '_SERVICE';